<!-- @format -->

<template>
  <div class="col-6 mx-auto text-center">
    <h1>This frame is empty</h1>
    <p>
      The page you're looking for isn't in the collection. Start over from the
      <RouterLink :to="{ name: 'home' }">homepage</RouterLink>, or browse the
      <RouterLink
        :to="{ name: 'collection', params: { collectionSlug: 'favorites' } }"
        >favorites</RouterLink
      >.
    </p>
  </div>
</template>

<script setup lang="ts">
import { setDocumentHead } from "@/composables/useDocumentHead";

setDocumentHead({
  title: "Not Found",
  description:
    "This page isn't in our collection. Browse Outstanding Photos for fine-art photography prints — landscapes, cities, and more, framed or unframed.",
});
</script>

<style></style>
